import { Input, Button, Switch, Form, Upload, Select } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addBodyShape, modifyBodyShape } from './BodyShapeSlice';
import type { UploadProps } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';


export default function AddBodyShape(): JSX.Element {
    const Cat = useSelector((state: AppState) => state.Category);
    const ProductTypesData = useSelector((state: AppState) => state.ProductTypes.ProductType);
    const [cat_array, setCatArray] = useState([{}]);
    const [type_array, setTypeArray] = useState([{}]);
    const dispatch = useDispatch();
    const { setModelChange, messageApi, editBodyShape, setEditBodyShape } = React.useContext(CommonContext) as CommonContextType;
    const [form] = Form.useForm();
    const [file, setFile] = useState<any>()
    const [fileList, setFileList] = useState<any>();
    const [type_nm_val, setTypeNmVal] = useState<any>(null);
    const [body_size_array, setBodySizeArray] = useState([{}]);
    const BodySizes = useSelector((state: AppState) => state.BodySizes);
    const [isDisabled, setIsDisabled] = useState(false);


    useEffect(() => {
        if (BodySizes.BodySize.length > 0) {
            const arr = BodySizes.BodySize.map((el: any) => ({ value: el.bodysize_value, label: el.bodysize_value }))
            setBodySizeArray(arr)
        }

    }, [BodySizes]);

    React.useEffect(() => {
        if (ProductTypesData.length > 0) {

            const a = [{ value: '', label: '' }];
            const arr = ProductTypesData.map((el: any) => ({ value: el.id, label: el.type_name }))
            setTypeArray([...a, ...arr]);

            // const arr = ProductTypesData.map((el: any) => ({ value: el.id, label: el.type_name }))
            // setTypeArray(arr);
        }


        if (Cat.CategoryArr.length > 0) {
            const arr = Cat.CategoryArr.map((el: any) => ({ value: el.id, label: el.category_name }))
            setCatArray(arr);
        }

        if (editBodyShape?.id) {
            setIsDisabled(editBodyShape.disabled)
            setFileList([
                {
                    name: editBodyShape.shape_img_url.split('/').pop(),
                    url: process.env.REACT_APP_AZURE_BLOB_STORAGE_API + editBodyShape.shape_img_url,
                }
            ])
            setFile(null)
            const catData = Cat.CategoryArr.find(cat => cat.id === editBodyShape?.cat?.id);
            setTypeNmVal(catData?.category_code)
            form.setFieldsValue(Object.assign({ type_nm: editBodyShape?.product_type?.id }, { body_sizes: editBodyShape?.body_size }, editBodyShape))
        } else {
            form.resetFields();
            setIsDisabled(false);
            setFileList(null);
            setFile(null);
        }
    }, [dispatch, editBodyShape, form]);

    const onFinish = (values: any) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('shape_name', values.shape_name);
        formData.append('shape_code', values.shape_code.toUpperCase());
        formData.append('nut_qty', values.nut_qty);
        formData.append('category_id', values.category_id);
        // if (values?.type_nm) {
        formData.append('product_type', (values?.type_nm) ? values.type_nm : "")
        formData.append('body_size', (values?.body_sizes) ? values.body_sizes : "")
        formData.append('order', values.order);
        formData.append('disabled', JSON.stringify(isDisabled))
        // }

        if (editBodyShape?.id) {
            formData.append('shape_img_url', editBodyShape.shape_img_url)
            formData.append('updated_datetime', new Date().toLocaleString() + "");
            dispatch(modifyBodyShape(formData, editBodyShape?.id))
            /* messageApi.open({
                type: 'success',
                content: 'Body Shape updated successfully',
            }); */
        } else {
            formData.append('created_datetime', new Date().toLocaleString() + "");
            dispatch(addBodyShape(formData))
        }



        setModelChange(false)
        setEditBodyShape(null)
        form.resetFields();
        setIsDisabled(false);
        setFileList(null);
        setFile(null);
    };
    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };
    const onChangeFile = (e: any) => {
        setFile(e.file.originFileObj)
    }

    const onToggleChange = (checked: boolean) => {
        setIsDisabled(checked)
    };

    const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
        newFileList[0].status = 'done'
        setFile(newFileList[0].originFileObj)
        setFileList(newFileList);
    }
    const props = {
        showUploadList: {
            showRemoveIcon: false,
            showPreviewIcon: false,
        },
    }
    const handleSelect = (value: string) => {
        console.log(`selected ${value}`);
    };
    const handleSelectCat = (value: any) => {
        // const data = Cat.CategoryArr.map((el: any) => ({ value: el.id, label: el.category_name }))
        const catData = Cat.CategoryArr.find(cat => cat.id === value);
        setTypeNmVal(catData?.category_code)
    };
    return (
        <Form
            form={form}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item name='key'>
                <Input type='hidden' />
            </Form.Item>

            <Form.Item>
                <Upload.Dragger
                    {...props}
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    maxCount={1}
                    accept="image/*"
                >
                    <div>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Drag file to upload </p> Or Select file from your PC
                    </div>
                </Upload.Dragger>
            </Form.Item>

            <Form.Item label="Order"
                name='order'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Order',
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: 'Please enter numbers only',
                    },
                ]}>
                <Input />
            </Form.Item>

            <Form.Item label="Shape Name"
                name='shape_name'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Body Shape name',
                    },
                ]}>
                <Input />
            </Form.Item>

            <Form.Item label="Shape Code"
                name='shape_code'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Body Shape code',
                    },
                ]}>
                <Input onInput={e => (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase()} />
            </Form.Item>


            <Form.Item label="Nut Qty"
                name='nut_qty'
                rules={[
                    {
                        required: true,
                        message: 'Please enter nut qty',
                    },
                ]}>
                <Select
                    // style={{ width: 120 }}
                    onChange={handleSelect}
                    options={[
                        { value: 2, label: 2 },
                        { value: 3, label: 3 }
                    ]}
                />
            </Form.Item>


            <Form.Item label="Category"
                name='category_id'
                rules={[
                    {
                        required: true,
                        message: 'Please enter category',
                    },
                ]}>
                <Select onChange={handleSelectCat}
                    // style={{ width: 120 }}
                    options={cat_array}
                />
            </Form.Item>



            <Form.Item label="Product Type"
                name='type_nm'
                rules={[
                    {
                        required: false
                    },
                ]}>
                <Select
                    // style={{ width: 120 }}
                    options={type_array}
                />
            </Form.Item>


            {type_nm_val == 'PUMP' ?
                <Form.Item label="Body Size"
                    name='body_sizes'
                    rules={[
                        {
                            required: true,
                            message: 'Please select body size',
                        },
                    ]}>
                    <Select //value={body_size}
                        options={body_size_array}>
                    </Select>
                </Form.Item>
                : null}


            <Form.Item >
                <Switch style={{ backgroundColor: isDisabled ? '#bfbfbf' : '#1577ff' }} checked={isDisabled} onChange={onToggleChange} checkedChildren="Disabled" unCheckedChildren="Enabled" />
            </Form.Item>

            <Form.Item>
                <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" >{editBodyShape?.id ? 'Update' : 'Create'}</Button>
            </Form.Item>
        </Form>
    )
}
